import styled from 'styled-components'

export const Container = styled.h2`
    font-size: 18px;
    font-weight: bold;
    color: #006600;
`